<template>
  <div class="">
    <div class="flex md:hidden">
      <BaseButton size="custom" variant="outline" id="global-catalog-filters-mobile-toggle" class="flex items-center !rounded-md px-1 py-0.5 text-base" @click="showFiltersForMobile = !showFiltersForMobile">
        <i class="ri-equalizer-line text-lg"></i>
        {{ t('catalog.filters') }}
      </BaseButton>
    </div>
    <!-- Filter for mobile -->
    <div class="mobile-filters block md:hidden h-screen overflow-y-auto no-scrollbar fixed top-0 left-0 right-0 bg-[#FFF] z-[1005]" v-if="showFiltersForMobile">
      <div class="flex justify-between p-4">
        <span class="font-semibold text-xl text-[#171717]">{{ t('catalog.filters') }}</span>
        <IconButton id="global-catalog-filters-mobile-close" icon="ri-close-line" ariaLabel="Close filters" size="sm" @click="showFiltersForMobile = false" />
      </div>
      <div class="bg-[#F0F0F0] p-4 border border-[#D1D1D1]" v-if="selectedFiltersLength">
        <ProductFilterChips />
      </div>
      <div class="flex flex-col space-y-4 text-sm text-gray-800 p-4">
        <div class="border-b">
          <h3 class="flex justify-between text-base font-semibold text-[#171717]">
            <span> Order Templates</span>
            <i class="ri-add-line text-xl cursor-pointer text-[#464646]" v-if="toggleOrderTemplates === false" @click="toggleOrderTemplates = true"></i>
            <i class="ri-subtract-line text-xl cursor-pointer text-[#464646]" v-else @click="toggleOrderTemplates = false"></i>
          </h3>
          <p class="text-[#6E6E6E] text-xs mb-2">View items from your templates</p>
          <div class="max-h-[240px] overflow-y-auto -mr-4 pr-2 mb-3" v-if="toggleOrderTemplates">
            <label v-for="template in orderTemplates" class="flex items-start gap-2">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="template" v-model="globalCatalogStore.selectedTemplates"/>
              <span class="[#464646]">{{ template.title }}</span>
            </label>
          </div>
        </div>
    
        <div class="border-b">
          <h3 class="flex justify-between font-semibold mb-3 text-[#171717]">
            <span>Categories</span>
            <i class="ri-add-line text-xl cursor-pointer text-[#464646]" v-if="toggleCategories === false" @click="toggleCategories = true"></i>
            <i class="ri-subtract-line text-xl cursor-pointer text-[#464646]" v-else @click="toggleCategories = false"></i>
          </h3>
          <div class="flex flex-col gap-1 max-h-[240px] overflow-y-auto -mr-4 pr-2 mb-3" v-if="toggleCategories">
            <ul class="flex flex-col gap-2">
              <CategoryFilterItem :category="category" v-for="category in categories" />
            </ul>
          </div>
        </div>
    
        <div class="border-b">
          <h3 class="flex justify-between font-semibold mb-3 text-[#171717]">
            <span>{{ t('orderCatalog.manufacturers') }}</span>
            <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleManufacturers === false" @click="toggleManufacturers = true"></i>
            <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleManufacturers = false"></i>
          </h3>
          <div class="space-y-1 max-h-[240px] overflow-y-auto -mr-4 pr-2 mb-3" v-if="toggleManufacturers">
            <label v-for="m in manufacturers" class="flex items-start gap-2">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="m" v-model="globalCatalogStore.selectedManufacturers" />
              <span class="[#464646]">{{ m.Manufacturer }}</span>
              <span class="text-[#6E6E6E]" v-if="formatCount(manufacturerCount(m))">({{ formatCount(manufacturerCount(m)) }})</span>
            </label>
          </div>
          <div v-if="toggleManufacturers" class="mt-1 mb-2">
            <a class="cursor-pointer" @click="openAllManufacturersModal()">
              <span class="font-normal text-sm underline underline-offset-2 text-[#000]">{{ t('orderCatalog.allManufactures') }}</span>
            </a>
          </div>
        </div>
    
        <div class="border-b">
          <h3 class="flex justify-between font-semibold mb-3 text-[#171717]">
            <span>List Type</span>
            <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleListTypes === false" @click="toggleListTypes = true"></i>
            <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleListTypes = false"></i>
          </h3>
          <div class="mb-4" v-if="toggleListTypes">
            <label v-for="type in listTypes" :key="type" class="flex items-start gap-2">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="type" v-model="globalCatalogStore.selectedListTypes" />
              <span class="[#464646]">{{ type }}</span>
            </label>
          </div>
        </div>

        <div class="border-b" v-if="colorOptions.length">
          <h3 class="flex justify-between font-semibold mb-3 text-[#171717]">
            <span>{{ t('catalog.color') }}</span>
            <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleColors === false" @click="toggleColors = true"></i>
            <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleColors = false"></i>
          </h3>
          <div class="space-y-1 max-h-[240px] overflow-y-auto -mr-4 pr-2 mb-3" v-if="toggleColors">
            <label v-for="option in colorOptions" :key="option.name" class="flex items-start gap-2">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="option.name" v-model="globalCatalogStore.selectedColors" />
              <span class="[#464646]">{{ option.name }}</span>
              <span class="text-[#6E6E6E]" v-if="formatCount(option.count)">({{ formatCount(option.count) }})</span>
            </label>
          </div>
        </div>

        <div class="pb-3 mb-4" v-if="sizeOptions.length">
          <h3 class="flex justify-between font-semibold mb-3 text-[#171717]">
            <span>{{ t('catalog.size') }}</span>
            <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleSizes === false" @click="toggleSizes = true"></i>
            <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleSizes = false"></i>
          </h3>
          <div class="space-y-1 max-h-[240px] overflow-y-auto -mr-4 pr-2 mb-3" v-if="toggleSizes">
            <label v-for="option in sizeOptions" :key="option.name" class="flex items-start gap-2">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="option.name" v-model="globalCatalogStore.selectedSizes" />
              <span class="[#464646]">{{ option.name }}</span>
              <span class="text-[#6E6E6E]" v-if="formatCount(option.count)">({{ formatCount(option.count) }})</span>
            </label>
          </div>
        </div>
      </div>

      <div class="flex justify-center items-center p-3 border border-[#D1D1D1] bg-[#FFF] fixed bottom-0 left-0 right-0">
        <BaseButton size="custom" id="global-catalog-apply-filters-mobile" class="rounded py-2 px-6 font-semibold text-base" @click="applyFilters()">
          Apply Filters <span v-if="selectedFiltersLength">({{ selectedFiltersLength }})</span>
        </BaseButton>
      </div>
    </div>

    <!-- Filters for Desktop -->
    <div class="space-y-4 text-sm text-[#464646] hidden md:flex md:flex-col w-[250px] shrink-0">
      <div class="border-b">
        <h3 class="flex items-center justify-between font-semibold text-[#171717]">
          <span> Order Templates</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleOrderTemplates === false" @click="toggleOrderTemplates = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleOrderTemplates = false"></i>
        </h3>
        <p class="text-[#6E6E6E] text-xs mb-3 -mt-1">View items from your templates</p>
        <div class="max-h-[240px] overflow-y-auto pr-1 mb-3" v-if="toggleOrderTemplates">
          <label v-for="template in orderTemplates" class="flex items-start gap-2">
            <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="template" v-model="globalCatalogStore.selectedTemplates"/>
            <span class="[#464646]">{{ template.title }}</span>
          </label>
        </div>
      </div>
  
      <div class="border-b">
        <h3 class="flex items-center justify-between font-semibold mb-3 text-[#171717]">
          <span>Categories</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleCategories === false" @click="toggleCategories = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleCategories = false"></i>
        </h3>
        <div class="flex flex-col gap-1 max-h-[240px] overflow-y-auto pr-1 mb-3" v-if="toggleCategories">
          <ul class="flex flex-col gap-2">
            <CategoryFilterItem :category="category" v-for="category in categories" />
          </ul>
        </div>
      </div>
  
      <div class="border-b">
        <h3 class="flex items-center justify-between font-semibold mb-3 text-[#171717]">
          <span>{{ t('orderCatalog.manufacturers') }}</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleManufacturers === false" @click="toggleManufacturers = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleManufacturers = false"></i>
        </h3>
        <div class="space-y-2 max-h-[240px] overflow-y-auto pr-1" v-if="toggleManufacturers">
          <label v-for="m in manufacturers" class="flex items-start gap-2">
            <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="m" v-model="globalCatalogStore.selectedManufacturers" />
            <span class="[#464646]">{{ m.Manufacturer }}</span>
            <span class="text-[#6E6E6E]" v-if="formatCount(manufacturerCount(m))">({{ formatCount(manufacturerCount(m)) }})</span>
          </label>
        </div>
        <div v-if="toggleManufacturers" class="mt-3 mb-2">
          <a class="cursor-pointer" @click="openAllManufacturersModal()">
            <span class="font-inter text-sm underline underline-offset-2 text-[#000]">{{ t('orderCatalog.allManufactures') }}</span>
          </a>
        </div>
      </div>
  
      <div class="border-b">
        <h3 class="flex items-center justify-between font-semibold mb-3 text-[#171717]">
          <span>List Type</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleListTypes === false" @click="toggleListTypes = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleListTypes = false"></i>
        </h3>
        <div class="mb-4" v-if="toggleListTypes">
          <label v-for="type in listTypes" :key="type" class="flex items-start gap-2">
            <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="type" v-model="globalCatalogStore.selectedListTypes" />
            <span class="[#464646]">{{ type }}</span>
          </label>
        </div>
      </div>

      <div class="border-b" v-if="colorOptions.length">
        <h3 class="flex items-center justify-between font-semibold mb-3 text-[#171717]">
          <span>{{ t('catalog.color') }}</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleColors === false" @click="toggleColors = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleColors = false"></i>
        </h3>
        <div class="space-y-2 max-h-[240px] overflow-y-auto pr-1 mb-4" v-if="toggleColors">
          <label v-for="option in colorOptions" :key="option.name" class="flex items-start gap-2">
            <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="option.name" v-model="globalCatalogStore.selectedColors" />
            <span class="[#464646]">{{ option.name }}</span>
            <span class="text-[#6E6E6E]" v-if="formatCount(option.count)">({{ formatCount(option.count) }})</span>
          </label>
        </div>
      </div>

      <div class="pb-3" v-if="sizeOptions.length">
        <h3 class="flex items-center justify-between font-semibold mb-3 text-[#171717]">
          <span>{{ t('catalog.size') }}</span>
          <i class="ri-add-line text-xl text-[#464646] cursor-pointer" v-if="toggleSizes === false" @click="toggleSizes = true"></i>
          <i class="ri-subtract-line text-xl text-[#464646] cursor-pointer" v-else @click="toggleSizes = false"></i>
        </h3>
        <div class="space-y-2 max-h-[240px] overflow-y-auto pr-1 mb-4" v-if="toggleSizes">
          <label v-for="option in sizeOptions" :key="option.name" class="flex items-start gap-2">
            <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="option.name" v-model="globalCatalogStore.selectedSizes" />
            <span class="[#464646]">{{ option.name }}</span>
            <span class="text-[#6E6E6E]" v-if="formatCount(option.count)">({{ formatCount(option.count) }})</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <Modal :showModal="showModal" :options="modalOptions" @close="showModal = false">
    <template #header>{{ t('orderCatalog.allManufactures') }}</template>
    <template #content>
      <div class="flex flex-col">
        <div class="grid grid-cols-2 gap-x-2">
          <div class="" v-for="m in allManufacturers">
            <label class="flex items-start gap-2 cursor-pointer">
              <input type="checkbox" class="custom-checkbox rounded border-gray-300 text-blue-600 mt-[2px]" :value="m" v-model="selectedAllManufacturers" />
              <span class="font-normal text-sm text-[#464646]">{{ m.Manufacturer }}</span>
              <span class="font-normal text-sm text-[#6E6E6E]" v-if="formatCount(manufacturerCount(m))">({{ formatCount(manufacturerCount(m)) }})</span>
            </label>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end items-center gap-2 mt-3">
        <BaseButton size="custom" variant="outline" class="h-10 w-[85px] !rounded text-base" @click="showModal = false">Cancel</BaseButton>
        <BaseButton size="custom" class="!rounded h-10 w-[77px] font-semibold text-base" @click="applyAllManufacturersFilter()">Apply</BaseButton>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useGlobalCatalogStore } from "@/stores/globalCatalogStore"
import CategoryFilterItem from '@/components/GlobalCatalog/CategoryFilterItem.vue';
import ProductFilterChips from '@/components/GlobalCatalog/Products/ProductFilterChips.vue';
import { useOrdersPageStore } from "@/stores/orderTemplateStore";
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies';
import Modal from '@/components/common/Modal.vue';
import BaseButton from '@/components/atoms/buttons/BaseButton.vue';
import IconButton from '@/components/atoms/buttons/IconButton.vue';
import { formatFacetCount } from '@/utilities/facetCountFormat';

const { t, locale } = useI18n()
locale.value = getLanguage();

const showModal = ref(false);
const modalOptions = {
  hasHeaderSeperation: true
}
const orderTemplateStore = useOrdersPageStore();
const globalCatalogStore = useGlobalCatalogStore();

const orderTemplates = computed(() => orderTemplateStore.orderTemplateData);
const categories = computed(() => globalCatalogStore.categories);
const allManufacturers = computed(() => globalCatalogStore.manufacturers);
const manufacturers = computed(() => globalCatalogStore.manufacturers.slice(1, 10))
const listTypes = computed(() => globalCatalogStore.listTypes);
// Color and Size options come from the search results, so these are empty until a search returns facets
const colorOptions = computed(() => globalCatalogStore.colorOptions);
const sizeOptions = computed(() => globalCatalogStore.sizeOptions);

const showFiltersForMobile = ref(false)

// Product counts shown next to each filter option, sourced from the search API facets.
// Options with a count of 0 remain selectable by design.
const formatCount = count => formatFacetCount(count);
const manufacturerCount = manufacturer => globalCatalogStore.getManufacturerProductCount(manufacturer);

const toggleOrderTemplates = ref(true);
const toggleCategories = ref(true);
const toggleManufacturers = ref(true);
const toggleListTypes = ref(true);
const toggleColors = ref(true);
const toggleSizes = ref(true);

const selectedFiltersLength = computed(() => 
  globalCatalogStore.selectedTemplates.length + 
  globalCatalogStore.selectedCategories.length + 
  globalCatalogStore.selectedManufacturers.length + 
  globalCatalogStore.selectedListTypes.length +
  globalCatalogStore.selectedColors.length +
  globalCatalogStore.selectedSizes.length
)

const applyFilters = () => {
  showFiltersForMobile.value = false;
}

const selectedAllManufacturers = ref([])

const openAllManufacturersModal = () => {
  selectedAllManufacturers.value = globalCatalogStore.selectedManufacturers;
  showModal.value = true;
}

const applyAllManufacturersFilter = () => {
  globalCatalogStore.selectedManufacturers = selectedAllManufacturers.value;
  showModal.value = false;
}

onMounted(() => {
  orderTemplateStore.fetchOrderTemplateDetails();
  // Counts must be present when landing directly on the Products page
  globalCatalogStore.loadFacetCounts();
});
</script>